export const bgColor = {
  backgroundColor: (theme) => theme.palette.background.secondary.dark,
};

export const SectionWrapper = {
  ...bgColor,
  px: { xs: 2, sm: 4, md: 8, lg: 14, xl: 27 },
  pt: 5,
};
